import { faMicrophone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

import { createUseStyles, useTheme } from "react-jss";

const useStyles = createUseStyles({
  microphone: {
    width: 24,
    height: 24,
  },
  "@media screen and (min-width: 688px) ": {
    microphone: {
      width: 32,
      height: 32,
    },
  },
});

const RecordButton = ({
  setIsRecording,
  disabled,
  startTimer,
  resetTimer,
  Mp3Recorder,
  ...rest
}) => {
  const theme = useTheme();
  const styles = useStyles({ theme });
  const [isBlocked, setIsBlocked] = useState(undefined);

  const start = () => {
    if (isBlocked === undefined) {
      try {
        navigator.getUserMedia(
          { audio: true },
          (x) => {
            console.log("Permission Granted");
            setIsBlocked(false);
            startTimer();
            Mp3Recorder.start()
              .then(() => {
                setIsRecording(true);
              })
              .catch((e) => console.error(e));
          },
          () => {
            console.log("Permission Denied");
            setIsBlocked(true);
          }
        );
      } catch (error) {
        navigator.mediaDevices.getUserMedia({ audio: true }).then(() => {
          console.log("Permission Granted");
          setIsBlocked(false);
          startTimer();
          Mp3Recorder.start()
            .then(() => {
              setIsRecording(true);
            })
            .catch((e) => console.error(e));
        });
      }
    } else if (isBlocked === true) {
      console.log("Permission Denied");
    } else {
      startTimer();
      Mp3Recorder.start()
        .then(() => {
          setIsRecording(true);
        })
        .catch((e) => console.error(e));
    }
  };

  return (
    <>
      <button {...rest}>
        <FontAwesomeIcon
          icon={faMicrophone}
          color={theme.recordBtnColor}
          className={styles.microphone}
          onClick={() => {
            if (!disabled) {
              start();
            }
          }}
        />
      </button>
    </>
  );
};

export { RecordButton };
